import React, { useEffect, useState, useCallback } from "react";
import { Button } from "@/components/ui/button";
import api, { formatMoney } from "@/lib/api";

const MONTHS = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

export default function AdminReportes() {
    const [year, setYear] = useState(new Date().getFullYear());
    const [data, setData] = useState(null);

    const load = useCallback(async (y) => {
        try { const { data: d } = await api.get(`/admin/reports?year=${y}`); setData(d); }
        catch (err) { /* noop */ }
    }, []);
    useEffect(() => { load(year); }, [year, load]);

    if (!data) return <div className="overline text-muted-foreground">Cargando reportes…</div>;
    const t = data.totals;

    return (
        <div className="space-y-4" data-testid="admin-reportes">
            <div className="flex items-center gap-3">
                <Button variant="outline" size="sm" onClick={() => setYear(year - 1)} className="rounded-none" data-testid="report-prev-year">←</Button>
                <span className="font-display text-3xl tabular" data-testid="report-year">{data.year}</span>
                <Button variant="outline" size="sm" onClick={() => setYear(year + 1)} className="rounded-none" data-testid="report-next-year">→</Button>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
                <Card label="Ventas totales" value={formatMoney(t.sales_amount)} testid="kpi-sales-amount" accent />
                <Card label="Ingresos registrados" value={formatMoney(t.payments_amount)} testid="kpi-payments" />
                <Card label="# Ventas cerradas" value={t.sales_count} testid="kpi-sales-count" />
                <Card label="Leads del año" value={t.leads} testid="kpi-leads" />
                <Card label="Ocupación anual" value={`${t.occupancy_pct}%`} sub={`${t.reserved_days} días reservados`} testid="kpi-occupancy" />
            </div>

            <div className="bg-white border border-border p-6 overflow-x-auto">
                <h3 className="font-display text-2xl mb-4">Detalle mensual {data.year}</h3>
                <table className="w-full text-xs" data-testid="report-monthly-table">
                    <thead className="bg-secondary">
                        <tr>
                            {["Mes", "Leads", "Ventas", "Monto ventas", "Ingresos (abonos)", "Días reservados", "% Ocupación"].map((h) => (
                                <th key={h} className="text-left px-3 py-2 overline">{h}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.monthly.map((m) => (
                            <tr key={m.month} className="border-t border-border">
                                <td className="px-3 py-2 font-display text-sm">{MONTHS[m.month - 1]}</td>
                                <td className="px-3 py-2 tabular">{m.leads}</td>
                                <td className="px-3 py-2 tabular">{m.sales}</td>
                                <td className="px-3 py-2 tabular">{formatMoney(m.sales_amount)}</td>
                                <td className="px-3 py-2 tabular">{formatMoney(m.payments_amount)}</td>
                                <td className="px-3 py-2 tabular">{m.reserved_days}</td>
                                <td className="px-3 py-2">
                                    <div className="flex items-center gap-2">
                                        <div className="h-2 bg-secondary w-24 overflow-hidden"><div className="h-full bg-accent" style={{ width: `${Math.min(100, m.occupancy_pct)}%` }} /></div>
                                        <span className="tabular">{m.occupancy_pct}%</span>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p className="text-[11px] text-muted-foreground mt-3">
                    La ocupación se calcula sobre los días marcados como <strong>Reservado</strong> en el Calendario. Los ingresos provienen de los abonos registrados en Ventas.
                </p>
            </div>
        </div>
    );
}

function Card({ label, value, sub, testid, accent }) {
    return (
        <div className={`bg-white border p-4 ${accent ? "border-accent" : "border-border"}`} data-testid={testid}>
            <div className="overline text-muted-foreground text-[10px]">{label}</div>
            <div className={`font-display text-3xl tabular mt-1 ${accent ? "text-accent" : ""}`}>{value}</div>
            {sub && <div className="text-[10px] text-muted-foreground mt-0.5">{sub}</div>}
        </div>
    );
}
